import { render, staticRenderFns } from "./CardBasic.vue?vue&type=template&id=50ea0413"
import script from "./CardBasic.vue?vue&type=script&lang=js"
export * from "./CardBasic.vue?vue&type=script&lang=js"
import style0 from "./CardBasic.vue?vue&type=style&index=0&id=50ea0413&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports